import { topicLabelFor } from '../../utils/topicLabel'
import { standardId } from '../../utils/standardRef'

// Facet + sort config for searchrooms, shared by the search palette and the
// sidebar filter popover. Kept in one place so both surfaces stay in sync.

// Build the facet config from loaded option lists. Option shapes match
// useSearchroomFilterOptions (standards: {label,standard}; authors: {_id,label};
// textTypes: strings) plus the user's topics ({_id,name}).
export function buildSearchroomFacets({
  standardOptions,
  authorOptions,
  textTypeOptions,
  topicOptions = [],
}) {
  const labelTopic = topicLabelFor(topicOptions)
  return [
    {
      key: 'topics',
      label: 'Topic',
      kind: 'multiselect',
      options: topicOptions,
      placeholder: 'Any topic',
      getOptionValue: (t) => t._id,
      getOptionLabel: labelTopic,
    },
    {
      key: 'standards',
      label: 'Standard',
      kind: 'multiselect',
      options: standardOptions,
      placeholder: 'Any standard',
      getOptionValue: (s) => standardId(s.standard),
      getOptionLabel: (s) => s.label,
    },
    {
      key: 'authors',
      label: 'Author',
      kind: 'multiselect',
      options: authorOptions,
      placeholder: 'Any author',
      getOptionValue: (a) => a._id,
      getOptionLabel: (a) => a.label,
    },
    {
      key: 'types',
      label: 'Text type',
      kind: 'multiselect',
      options: textTypeOptions,
      placeholder: 'Any type',
      getOptionValue: (t) => t._id,
      getOptionLabel: (t) => t.label,
    },
    { key: 'updated', label: 'Updated', kind: 'daterange' },
  ]
}

// Sort orders offered in the UI; `value` matches the server's sort keys.
export const SEARCHROOM_SORTS = [
  { value: 'updated', label: 'Recently updated' },
  { value: 'updatedAsc', label: 'Oldest updated' },
  { value: 'name', label: 'Name A–Z' },
  { value: 'nameDesc', label: 'Name Z–A' },
]

// Map the palette/popover raw facet values (selected option objects + a date
// range) into the primitive arrays/strings the searchrooms service expects.
export function facetsToParams(facetValues = {}) {
  const updated = facetValues.updated || {}
  return {
    standards: (facetValues.standards || []).map((s) => standardId(s.standard)),
    authors: (facetValues.authors || []).map((a) => a._id),
    types: (facetValues.types || []).map((t) => t._id),
    topics: (facetValues.topics || []).map((t) => t._id),
    updatedFrom: updated.from || '',
    updatedTo: updated.to || '',
  }
}

// True when any facet is actually constraining the list (used to show the
// active-filter indicator and enable "Clear all").
export function hasActiveFilters(facetValues = {}) {
  const updated = facetValues.updated || {}
  return Boolean(
    facetValues.topics?.length ||
      facetValues.standards?.length ||
      facetValues.authors?.length ||
      facetValues.types?.length ||
      updated.from ||
      updated.to
  )
}
